import { useReducer } from "react";

function useCustomReducer(initialState) {
  //Customised reducer to look like the state of a react class
  const reducer = (state, action) => {
    let _temp = Object.assign({}, state);
    if (typeof action === "function") {
      _temp = action(state);
    } else if (typeof action === "object") {
      for (const key of Object.keys(action)) {
        _temp[key] = action[key];
      }
    }
    return _temp;
  };
  const [state, setState] = useReducer(reducer, initialState);
  return [state, setState];
}
export default useCustomReducer;
